export const getIdsInMentions = text => {
  const userIdGroups = text.matchAll(/data-id="([^"]*)"/g)
  return [...userIdGroups].map(group => group[1])
}

// export const resolveMentions = (text, userIds, users) => {
//   const div = document.createElement('div')
//   div.innerHTML = text
//   userIds.forEach(userId => {
//     if (!(users && userId in users && users[userId] && 'name' in users[userId])) {
//       return div.innerHTML
//     }
//     const mentions = div.querySelectorAll(`span[data-id="${userId}"]`)
//     mentions.forEach(mention => {
//       mention.dataset.label = users[userId].name
//       mention.textContent = '@' + users[userId].name
//     })
//   })
//
//   return div.innerHTML
// }

export const resolveMentions = (text, userIds, users) => {
  return text.replace(
    /<span([^>]*\sdata-id="([\w\s\-_:]*)"[^>]*)>([^<]*)<\/span>/g,
    (match, attrs, id) => {
      if (userIds.includes(id) && users?.[id]?.name) {
        const name = users[id].name
        const cleanedAttrs = attrs.replace(/\sdata-label="[^"]*"/, '')

        const restAttrs = cleanedAttrs ? ` ${cleanedAttrs.trim()}` : ''

        return `<span${restAttrs} data-label="${name}">@${name}</span>`
      }
      return match
    }
  )
}

export const DESCRIPTION_FILED_LIMITS = {
  DESCRIPTION: 17500,
  COMMENT: 10000,
  COMMON: 18000
}
